import { render, staticRenderFns } from "./site-list.vue?vue&type=template&id=2f0f8478&scoped=true&"
import script from "./site-list.js?vue&type=script&lang=js&"
export * from "./site-list.js?vue&type=script&lang=js&"
import style0 from "./site-list.scss?vue&type=style&index=0&id=2f0f8478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f8478",
  null
  
)

component.options.__file = "site-list.vue"
export default component.exports